import axios from 'redaxios';

const selectors = {
  wrapper: '[data-product-add-popdown-wrapper]',
  closeDrawer: '[data-close-popdown]',
  apiContent: '[data-api-content]',
  cartAjaxEnabled: '[data-ajax-disable="false"]',
  cartAjaxDisabled: '[data-ajax-disable="true"]',
  cartToggleButton: '[data-drawer-toggle="drawer-cart"]',
  cartDrawer: '[data-drawer="drawer-cart"]',
};

const classes = {
  visible: 'is-visible',
};

let globalTimer;

class CartPopdown {
  constructor() {
    this.drawer = document.querySelector(selectors.wrapper);
    this.cartAjaxEnabled = document.querySelector(selectors.cartAjaxEnabled);
    this.cartAjaxDisabled = document.querySelector(selectors.cartAjaxDisabled);
    document.addEventListener('theme:cart:popdown', (e) => {
      if (this.cartAjaxEnabled) {
        // if we are on the cart page, refresh the cart without popdown
        this.cartAjaxEnabled.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
      } else if (this.cartAjaxDisabled) {
        // ajax is disabled, refresh the whole page
        window.location.reload();
      } else {
        this.renderPopdown(e);
      }
    });
  }

  renderPopdown(event) {
    const variant = event.detail.variant;
    const url = `${window.theme.routes.root_url}variants/${variant.id}/?section_id=api-product-popdown`;
    const instance = this;
    axios
      .get(url)
      .then(function (response) {
        // handle success
        const fresh = document.createElement('div');
        fresh.innerHTML = response.data;
        instance.drawer.innerHTML = fresh.querySelector(selectors.apiContent).innerHTML;
        instance.connectCartButton();
        instance.connectCloseButton();
      })
      .catch(function (error) {
        console.warn(error);
      });
  }

  connectCloseButton() {
    // Enable close button
    this.drawer.classList.add(classes.visible);
    const closer = this.drawer.querySelector(selectors.closeDrawer);
    closer.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        this.drawer.classList.remove(classes.visible);
      }.bind(this)
    );
    this.popdownTimer();
  }

  connectCartButton() {
    // Hook into cart drawer
    const cartButton = this.drawer.querySelector(selectors.cartToggleButton);
    const cartDrawer = document.querySelector(selectors.cartDrawer);

    if (cartDrawer) {
      cartButton.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          this.drawer.classList.remove(classes.visible);
          cartDrawer.dispatchEvent(
            new CustomEvent('theme:drawer:open', {
              bubbles: false,
            })
          );
        }.bind(this)
      );
    }
  }

  popdownTimer() {
    clearTimeout(globalTimer);
    globalTimer = setTimeout(() => {
      this.drawer.classList.remove(classes.visible);
    }, 5000);
  }
}

const cartPopdown = {
  onLoad() {
    new CartPopdown(this);
  },
};

export default cartPopdown;
